import React from "react";
import PropTypes from "prop-types";

const MagazineSection = ({section}) => {
  let { content, colour, bgColour, topMargin, bottomMargin, heading } = section;

  return (
    <div className={`wrapper block-wrapper bg-${bgColour} ${topMargin} ${bottomMargin}`}>
      <div className="wrapper--inner flex flex-w-w flex-jc-sb">
        <div className={`latest-mag flex flex-w-w flex-jc-sb bg-${colour} col-1`}>
          <a href={content.url}>
            <img alt={content.image_alt} src={content.image} srcSet={content.image_srcset} />
          </a>
          <div className="latest-mag-copy">
            {heading && <h3 className={`h1 ff-s color-${colour}`} dangerouslySetInnerHTML={{__html: heading}}></h3>}
            <div dangerouslySetInnerHTML={{__html: content.content}}></div>
            <a href={content.url} className={`btn-m-m btn-${colour} dib-m`}>{content.button}</a>
          </div>
        </div>
      </div>
    </div>
  );
}


MagazineSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default MagazineSection;
